import React from 'react';
import './MafiaCountdown.css';

// Добавили проп isDanger (по умолчанию true, чтобы привлекать внимание)
const MafiaCountdown = ({ value, isDanger = true }) => {
  if (value === null || value === undefined) return null;

  return (
    <div className="mafia-countdown-wrapper">
      <div
        key={value}
        // Если isDanger === false, добавляем класс neutral
        className={`mafia-countdown-number ${!isDanger ? 'neutral' : ''}`}
      >
        {value}
      </div>
    </div>
  );
};

export default MafiaCountdown;